import axios from '@axios'

export const state = {
  fees: [],
  payments: [],
  costs: [],
  total_fee: 0,
  total_payment: 0,
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allFees: (state) => state.fees,
  totalFee: (state) => state.total_fee,
  totalPayment: (state) => state.total_payment,
  allPayments: (state) => state.payments,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
  allCosts: (state) => state.costs,
}

export const mutations = {
  GET_FEE_AND_PAYMENT_SUM: (state) => {
    state.total_fee = state.fees
      .map((item) => item.amount)
      .reduce((partialSum, a) => partialSum + a, 0)
    state.total_payment = state.payments
      .map((item) => item.amount)
      .reduce((partialSum, a) => partialSum + a, 0)
  },
  GET_FEES: (state, resp) => {
    if (!resp) return null
    state.payments = resp.fees.filter((fee) => fee.type === 'payment')
    state.costs = resp.fees.filter((fee) => fee.type.endsWith('_cost'))
    state.fees = resp.fees.filter((fee) => fee.type.endsWith('_fee'))
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  CREATE_FEE: (state, resp) => {
    if (!resp) return null

    const tergeStateKey =
      resp.type === 'payment'
        ? 'payments'
        : resp.type.endsWith('_fee')
        ? 'fees'
        : resp.type.endsWith('_cost')
        ? 'costs'
        : null

    state[tergeStateKey].push(resp)
  },
  UPDATE_FEE: (state, resp) => {
    if (!resp) return null
    const tergeStateKey =
      resp.type === 'payment'
        ? 'payments'
        : resp.type.endsWith('_fee')
        ? 'fees'
        : resp.type.endsWith('_cost')
        ? 'costs'
        : null
    let tergetIndex = state[tergeStateKey].findIndex(
      (fee) => fee.id === resp.id
    )
    state[tergeStateKey][tergetIndex] = { ...resp }
  },
  DELETE_FEE: (state, resp) => {
    if (!resp) return null
    const tergeStateKey =
      resp.type === 'payment'
        ? 'payments'
        : resp.type.endsWith('_fee')
        ? 'fees'
        : resp.type.endsWith('_cost')
        ? 'costs'
        : null
    state[tergeStateKey] = [
      ...state[tergeStateKey].filter((fee) => fee.id !== resp.id),
    ]
  },
}

export const actions = {
  async getFees({ commit }, params = {}) {
    await axios
      .get('/api/fees', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_FEES', resp.data)
          commit('GET_FEE_AND_PAYMENT_SUM')
        }
      })
      .catch((err) => {
        commit('GET_FEES', err.response.status === 404 ? { fees: [] } : null)
        commit('GET_FEE_AND_PAYMENT_SUM')
      })
  },
  async createFee({ commit, dispatch }, form) {
    return axios.post('/api/fees', form)
  },

  async updateFee({ commit, dispatch }, form) {
    return axios.put('/api/fees', form)
  },
  async deleteFee({ commit, dispatch }, form) {
    return axios.delete(`/api/fees`, { data: { ...form } })
  },
  async createPayment({ commit, dispatch }, form) {
    return axios.post('/api/payments', form)
  },
  async updatePayment({ commit, dispatch }, form) {
    return axios.put('/api/payments', form)
  },
}
